import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { emailValidator } from '../email';
import { apiCall } from '../API';
import AsyncActionStore from './AsyncActionStore';
import InputStore from './InputStore';

export default class ForgotPasswordStore {
    static PropType = PropTypes.shape({
        apiSubmitState: AsyncActionStore.PropType.isRequired,
        email: InputStore.PropType.isRequired,
        submit: PropTypes.func.isRequired,
        tryAgain: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class ForgotPasswordStore */{
            apiSubmit: apiCall('/console/password/request'),
            apiSubmitState: new AsyncActionStore(),
            email: new InputStore({ value: '', isTouched: true }),
        }, data);

        this.email.setValidator(emailValidator);
    }

    submit = action(() => {
        if (this.apiSubmitState.isLoading) {
            return;
        }

        this.apiSubmitState.setBase();

        this.email.setTouched(false);
        if (!this.email.isValid) {
            this.email.focus();
            return;
        }

        this.email.blur();
        this.apiSubmitState.setLoading(this.apiSubmit({ email: this.email.value }))
            .catch(() => this.email.focus());
    });

    tryAgain = action(() => {
        this.apiSubmitState.setBase();
        this.email.setValue('');
        this.email.focus();
    });
}
